export function formatSessionUsers(users = []) {
  const names = Array.isArray(users) ? users.map((name) => String(name || '').trim()).filter(Boolean) : [];
  if (!names.length) return '';
  return names.join(', ');
}

export function formatSshPolicy(host = {}) {
  const parts = [];
  if (host.permitRootLogin) parts.push(`root ${host.permitRootLogin}`);
  if (host.passwordAuth) parts.push(`password ${host.passwordAuth}`);
  if (host.pubkeyAuth) parts.push(`pubkey ${host.pubkeyAuth}`);
  if (parts.length) return parts.join(' · ');
  if (host.partial && String(host.ssh || '').toUpperCase() === 'OK') return 'sshd policy needs root';
  return '';
}

export function countOrDash(value) {
  if (value == null || value === '') return '—';
  return String(value);
}
